module.exports = "<div class=\"fleets-screen\">\n\t<div class=\"fleet-placeholder-desktop\">\n\t\t<img src=\"assets/fleets-main-desktop.PNG\" alt=\"\">\n\t</div>\n\n\t<div class=\"fleet-placeholder-mobile\">\n\t\t<img src=\"assets/fleets-main-mobile.PNG\" alt=\"\">\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/fleets/fleets.html
// module id = ./src/app/components/fleets/fleets.html
// module chunks = main